<template>
  <div class="footer">
    <div
      v-if="
        typePlacesSelectedTickets.length > 0 &&
          typePlacesSelectedTickets.find(t => t.variants.length)
      "
      class="type-tickets-select--wrapper"
      v-bind:class="{ selectTypeTicketsStep }"
    >
      <div
        class="type-tickets-select--switch-control"
        v-bind:class="{ close: !isOpenControlTypeTickets }"
        @click="() => (isOpenControlTypeTickets = !isOpenControlTypeTickets)"
        v-if="selectTypeTicketsStep"
      >
        <img :src="switchControlSelectTypeSVG" alt="" />
      </div>
      <div v-if="selectTypeTicketsStep && isOpenControlTypeTickets">
        <div
          v-for="(ticket, index) in typePlacesSelectedTickets"
          :key="`type-tickets-select--select-block-${index}`"
          class="type-tickets-select--select-block"
        >
          <div class="type-tickets-select--select-list">
            <div
              :key="`${variants.name}-${index}`"
              v-for="(variants, index) in ticket.variants"
              class="type-tickets-select--select-list-item"
            >
              <div class="type-tickets-select--select-list-item-select"
                   :class="{ 'overFour': ticket.variants.length > 4}" >
                <div
                  class="type-tickets-select--select-list-item-select-minus"
                  @click="
                    () =>
                      decreaseTicketTypeHandler(ticket.name, variants.typeId)
                  "
                ></div>
                <div class="type-tickets-select--select-list-item-select-name">
                  <p>
                    {{
                      cart.tickets.filter(
                        ({ name, typeId }) =>
                          name === ticket.name && typeId === variants.typeId,
                      ).length
                    }}
                    {{ variants.Name }}
                  </p>
                </div>
                <div
                  class="type-tickets-select--select-list-item-select-plus"
                  @click="
                    () =>
                      increaseTicketTypeHandler(ticket.name, variants.typeId)
                  "
                ></div>
              </div>
              <div class="type-tickets-select--select-list-item-info">
                <p>{{ ticket.name }}</p>
                <p>{{ variants.Sum }} {{ setting.currency }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hall-basket-wrapper">
      <div class="footer-desktop">
        <div
          v-if="!session.NoSeats"
          class="place-type-list"
          v-bind:class="{ selectedPlace: cart.tickets.length }"
        >
          <div
            class="place-type"
            v-for="price in session.Prices"
            :key="price.Id"
          >
            <span
              class="place-type-icon"
              :style="{ background: getColor(price) }"
            ></span>
            <span>{{ price.Name }} {{ price.Sum }} {{ setting.currency }}</span>
          </div>
          <div class="place-type">
            <span
              class="place-type-icon"
              :style="{ background: '#59636b' }"
            ></span>
            <span>Место занято</span>
          </div>
        </div>
        <div class="basket-info" v-if="cart.tickets.length > 0">
          <div
            v-if="typePlacesSelectedTickets.length > 0 && selectTypeTicketsStep"
            v-for="(ticket, index) in typePlacesSelectedTickets"
            :key="index"
          >
            <label class="basket-info-label">
              {{
                `${
                  cart.tickets.filter(
                    ({ name, typeId }) => name === ticket.name && typeId,
                  ).length
                } из ${countTicketString(
                  cart.tickets.filter(({ name }) => name === ticket.name)
                    .length,
                  true,
                )}`
              }}
              за
              {{
                cart.tickets
                  .filter(({ name, price }) => name === ticket.name && price)
                  .reduce((acc, item) => acc + item.price, 0)
              }}
              {{ setting.currency }}
            </label>
            <label class="basket-info-label basket-info-label-gray">{{
              ticket.name
            }}</label>
          </div>
          <label v-if="!selectTypeTicketsStep && cart.tickets.filter(({ price }) => price).length" class="basket-info-label">
            {{ countTicketString(cart.tickets.length) }} за
            {{ cartTicketsSum }}
          </label>

          <label v-else-if="cart.tickets.filter(({ price }) => price).length" class="basket-info-label">
            Сумма: {{ cartTicketsSum }}
          </label>
          <label v-if="cart.tickets.filter(({ price }) => price).length" class="basket-info-label basket-info-label-gray"
            >Без сервисного сбора</label
          >
        </div>
        <div class="basket-step" v-if="cart.tickets.length > 0">
          <div
            class="basket-btn"
            v-bind:class="{
              disabled: false,
            }"
            @click="reserveTicket"
          >
            <span class="btn-icon"></span>
            <span class="btn-label">{{ basketBtnText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Footer',

  data() {
    return {
      switchControlSelectTypeSVG: require('../assets/switch-control-select-type.svg'),
      isOpenControlTypeTickets: true,
      selectTypeTicketsStep: false,
    };
  },

  computed: {
    ...mapState(['session', 'cart', 'bar', 'errors', 'setting']),
    basketBtnText() {
      if (
        this.cart.tickets.length &&
        this.cart.tickets.filter(({ price }) => !price).length ===
          this.cart.tickets.length
      ) {
        return 'Получить';
      }

      if (!this.selectTypeTicketsStep) return 'Купить';

      if (this.cart.tickets.filter(({ price }) => !price).length) {
        return `Выберите тип для ${this.countTicketString(
          this.cart.tickets.filter(({ price }) => !price).length,
          true,
        )} `;
      }

      return 'Купить';
    },

    basketBtnOptions() {
      if (!this.selectTypeTicketsStep) {
        return { disabled: false, label: 'Купить' };
      }

      if (this.selectTypeTicketsStep) {
        return {
          disabled: true,
          label:
            this.cart.tickets.filter(({ price }) => price).length ===
            this.cart.tickets.length
              ? 'Купить'
              : `Выберите тип билета для ${this.cart.tickets.length -
                  this.cart.tickets.filter(({ price }) => price)} билета
                 `,
        };
      }
    },
    cartTicketsSum() {
      let sum = 0;
      this.cart.tickets.forEach(ticket => {
        sum += ticket.price;
      });

      return sum + ' ' +  this.setting.currency;
    },
    typePlacesSelectedTickets() {
      return this.cart.tickets
        .filter(
          (ticket, index, array) =>
            !array.slice(0, index).find(i => i.name == ticket.name),
        )
        .map(({ name, variants }) => ({
          name,
          variants,
          count: this.cart.tickets.filter(i => i.name === name).length,
        }));
    },
  },

  methods: {
    decreaseTicketTypeHandler(typeTicketName, typeDiscountTicket) {
      const changeTicket = this.cart.tickets.find(
        ticket =>
          ticket.name === typeTicketName &&
          ticket.typeId === typeDiscountTicket,
      );

      this.cart.tickets = this.cart.tickets.map(ticket => {
        if (ticket.id === changeTicket.id) {
          this.cart.sum -= changeTicket.price;
          this.cart.ticketSum -= changeTicket.price;
          return { ...ticket, price: null, typeId: null };
        }

        return ticket;
      });
    },
    increaseTicketTypeHandler(typeTicketName, typeDiscountTicket) {
      const changeTicket = this.cart.tickets.find(
        ticket =>
          !ticket.price && !ticket.typeId && ticket.name === typeTicketName,
      );

      this.cart.tickets = this.cart.tickets.map(ticket => {
        if (ticket.id === changeTicket.id) {
          const selectedVariants = ticket.variants.find(
            ({ typeId }) => typeId === typeDiscountTicket,
          );
          this.cart.sum += selectedVariants.Sum;
          this.cart.ticketSum += selectedVariants.Sum;
          return {
            ...ticket,
            price: selectedVariants.Sum,
            typeId: typeDiscountTicket,
          };
        }

        return ticket;
      });
    },
    log: msg => console.log(msg),
    getColor(price) {
      return price.Color.slice(0, -2);
    },
    countTicketString(tickets, suffOv) {
      if (suffOv) {
        return tickets < 2 ? `${tickets} билета` : `${tickets} билетов`;
      }

      return tickets === 1
        ? `${tickets} билет`
        : tickets > 1 && tickets < 5
        ? `${tickets} билета`
        : `${tickets} билетов`;
    },
    ticketString(tickets) {
      return tickets === 1
        ? 'билет'
        : tickets > 1 && tickets < 5
        ? 'билета'
        : 'билетов';
    },

    reserveTicket() {


      if (
        !this.selectTypeTicketsStep &&
        this.cart.tickets.some(ticket => ticket.variants.length > 1)
      ) {
        this.selectTypeTicketsStep = !this.selectTypeTicketsStep;
        return;
      }



      if (this.cart.tickets.every(({ typeId }) => typeId) || this.session.NoSeats) {
        const roistatVisit = this.$route.query.roistatVisit;

        this.$store
          .dispatch('reserveTicket', {
            theatreId: this.$route.params.theatreId,
            sessionId: this.$route.params.session,
          })
          .then(() => {
            if (this.errors.length) {
              this.$router.push(
                `/${this.$route.params.theatreId}/${this.$route.params.session}/hall/${roistatVisit ? `?roistatVisit=${roistatVisit}` : ''}`,
              );
            } else {
              if (this.bar.length) {
                this.$router.push(
                  `/${this.$route.params.theatreId}/${this.$route.params.session}/bar/${roistatVisit ? `?roistatVisit=${roistatVisit}` : ''}`,
                );
              } else if (
                this.session &&
                this.session.Hall &&
                this.session.Hall.HallType &&
                this.session.Hall.HallType.Name === 'Мероприятия'
              ) {
                this.$router.push(
                  `/${this.$route.params.theatreId}/${this.$route.params.session}/support-cultural-program/${roistatVisit ? `?roistatVisit=${roistatVisit}` : ''}`,
                );
              } else {
                this.$router.push(
                  `/${this.$route.params.theatreId}/${this.$route.params.session}/buy/${roistatVisit ? `?roistatVisit=${roistatVisit}` : ''}`,
                );
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.footer {
  border-top: 1px solid #cdcfd024;
  background-color: #24262c;
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  min-height: 56px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10002;
}

.footer-mobile {
  display: none;
}

.hall-basket-wrapper {
  padding: 10px 15px;
  border-top: 1px solid #3b3d43;
}

.footer-desktop {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: stretch;
  align-items: flex-start;
  justify-content: space-between;
}

.place-type-list {
  display: flex;
  width: 100%;
  min-height: 56px;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 400px;
  margin: 0 auto;
}

.place-type {
  color: #bdbec0;
  margin: 3px 20px 10px 0;
  white-space: nowrap;
  font-size: 12px;
}

.place-type-icon {
  display: inline-block;
  margin: 0 5px 0 0;
  width: 8px;
  height: 8px;
  background: rgb(89, 99, 107);
  border-radius: 12px;
}

.basket-info {
  align-self: center;
  justify-content: center;
  margin-left: 50px;
}

.basket-info .basket-info-label {
  text-align: right;
  color: #fff;
  line-height: 1.2;
  cursor: default;
  width: 100%;
  display: block;
  text-align: center;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.basket-info .basket-info-label-gray {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.5;
  opacity: 0.5;
}

.basket-step {
  flex: 0 0 250px;
  align-items: flex-start;
}

.basket-btn {
  height: 42px;
  font-family: HelveticaNeueMedium, HelveticaNeue-Medium, Helvetica Neue Medium,
    HelveticaNeue, Helvetica Neue, TeXGyreHerosRegular, HelveticaNeueMediumLocal,
    Helvetica, Tahoma, Geneva, Arial, sans-serif;
  font-size: 16px;
  letter-spacing: 2px;
  padding: 0 32px;
  height: 56px;
  border-radius: 4px;
  background: #0d76ff;
  color: #fff;
  text-transform: uppercase;
  box-sizing: border-box;
  overflow: hidden;
  line-height: 22px;
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  transition: all 0.05s;
  &.disabled {
    opacity: 0.35;
  }
  .btn-label {
    line-height: normal;
  }
}

.basket-btn:hover {
  cursor: pointer;
  opacity: 0.85;
}
@media only screen and (min-width: 768px), screen and (orientation: landscape) {
  .place-type-list {
    width: auto;
    justify-content: flex-start;
  }
  .basket-step {
    flex: 0 0 250px;
    align-items: flex-start;
  }
}

@media only screen and (min-width: 1024px) {
  .basket-info {
    padding: 0 20px 0 0;
    align-self: center;
    flex: 1 0 auto;
  }
  .basket-info .basket-info-label {
    text-align: right;
  }
}

@media only screen and (max-width: 768px), screen and (orientation: landscape) {
  .basket-step-forward {
    width: 100%;
  }
}

@media only screen and (max-width: 480px), screen and (orientation: landscape) {
  .footer {
    position: fixed;
  }

  .place-type {
    margin: 3px 10px 10px 0;
  }

  .place-type-list {
    min-height: 27px;
  }

  .basket-info {
    margin: 0;
    flex-direction: row;
    width: 100%;
    margin-bottom: 10px;
  }

  .basket-step {
    flex-direction: row;
    width: 100%;
    flex: 100%;
  }
}

@media only screen and (orientation: landscape) {
  .basket-info {
    width: auto;
    margin: 0 15px;
  }

  .basket-step {
    width: auto;
    flex: auto;
  }

  .place-type-list {
    min-height: 55px;
  }
}

@media only screen and (max-width: 320px), screen and (orientation: landscape) {
  .footer {
    margin-bottom: 0;
  }
}

@media (max-width: 768px) {
  .basket-info {
    margin: 0 auto;
    width: 100%;
  }
  .basket-step {
    flex: auto;
  }
}

@media (min-width: 768px) {
  .home {
    .place-type-list {
      &.selectedPlace {
        display: block;
      }
    }

    .basket-info {
      margin-left: auto;
      margin-right: 1rem;
    }

    .basket-step {
      max-width: 500px;
    }
  }
}

.type-tickets-select {
  &--wrapper {
    // position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 9;
    &.selectTypeTicketsStep {
      padding-top: 15px;
      border-top: 1px solid #3b3d43;
      min-height: 10px;

      @media screen and (max-width: 900px){
        max-height: 40vh;
        overflow-y: scroll;
      }
    }
  }

  &--switch-control {
    display: block;
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 26px;
    height: 11px;
    // transition: all 0.05s;
    padding: 1rem;
    cursor: pointer;
    &.close {
      transform: translate(-50%, -50%) rotate(180deg);
    }
  }

  &--select-block {
    background: #24262c;
    width: 100%;
    min-height: 82px;
    transition: all 0.5s;
    & > :not(:first-child) {
      border-top: 1px solid #3b3d43;
    }
  }

  &--select-list {
    min-height: 82px;
    background: #24262c;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &-item {
      margin: 10px 0;
      &-select {
        display: flex;
        min-width: 240px;
        justify-content: center;
        align-items: center;

        &.overFour {
          min-width: 200px;
        }
        &-minus,
        &-plus {
          width: 16px;
          height: 16px;
          border: 2px solid #ffffff;
          border-radius: 50%;
          position: relative;
          cursor: pointer;
          &:before,
          &:after {
            position: absolute;
            left: 50%;
            top: 50%;
            background: #fff;
            content: '';
          }
          &:before {
            width: 7.5px;
            height: 2px;
            transform: translate(-50%, -50%);
          }
        }

        &-plus {
          &:after {
            width: 7.5px;
            height: 2px;
            transform: translate(-50%, -50%) rotate(90deg);
          }
        }

        &-name {
          font-size: 16px;
          line-height: 18px;
          color: #ffffff;
          margin: 0 10px;
        }
      }
      &-info {
        font-size: 14px;
        line-height: 16px;
        color: #8f9193;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
}

@media (min-width: 768px) {
  .type-tickets-select {
    &--select-list {
      flex-direction: row;
      &-item {
        margin: 0;
      }
    }
  }
}
</style>
